import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["inputRef", "referenceElementRef"];
import React from 'react';
import Hint from '../Hint';
import Input from '../Input';
import { propsWithBsClassName } from '../../utils';
var TypeaheadInputSingle = function TypeaheadInputSingle(_ref) {
  var inputRef = _ref.inputRef,
    referenceElementRef = _ref.referenceElementRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Hint, null, /*#__PURE__*/React.createElement(Input, _extends({}, propsWithBsClassName(props), {
    ref: function ref(node) {
      inputRef(node);
      referenceElementRef(node);
    }
  })));
};
export default TypeaheadInputSingle;